export interface VideoAvatarOption {
  id: string;
  name: string;
  previewImageUrl: string | null;
  gender: string | null;
}

export interface VoiceOption {
  id: string;
  label: string;
}

export type PersonaMediaValues = {
  voice: string | null;
  voiceProvider: string | null;
  videoAvatarId: string | null;
};

type Props = {
  voice: string | null;
  voiceProvider: string | null;
  videoAvatarId: string | null;
  voiceProviderName: string;
  voiceOptions: VoiceOption[];
  videoAvatars: VideoAvatarOption[];
  disabled?: boolean;
  onChange: (patch: Partial<PersonaMediaValues>) => void;
  voiceFieldId?: string;
  videoFieldId?: string;
};

const AUTO_VOICE = '';

export function PersonaVoiceVideoFields({
  voice,
  voiceProvider,
  videoAvatarId,
  voiceProviderName,
  voiceOptions,
  videoAvatars,
  disabled = false,
  onChange,
  voiceFieldId = 'persona-voice',
  videoFieldId = 'persona-video-avatar',
}: Props) {
  const voiceSelectValue = voice && voiceProvider === voiceProviderName ? voice : AUTO_VOICE;

  return (
    <div className="space-y-3">
      <div>
        <label htmlFor={voiceFieldId} className="block text-xs text-gray-600 mb-0.5">
          Voice ({voiceProviderName})
        </label>
        <select
          id={voiceFieldId}
          disabled={disabled}
          className="w-full border rounded px-2 py-1 text-sm"
          value={voiceSelectValue}
          onChange={(e) => {
            const v = e.target.value;
            if (!v) {
              onChange({ voice: null, voiceProvider: null });
            } else {
              onChange({ voice: v, voiceProvider: voiceProviderName });
            }
          }}
        >
          <option value={AUTO_VOICE}>Auto (assigned per session)</option>
          {voiceOptions.map((opt) => (
            <option key={opt.id} value={opt.id}>
              {opt.label}
            </option>
          ))}
        </select>
        <p className="text-xs text-gray-500 mt-0.5">
          Text-to-speech voice for verbal practice. Auto assigns a distinct voice per session when
          unset.
        </p>
      </div>
      {videoAvatars.length > 0 && (
        <div>
          <label htmlFor={videoFieldId} className="block text-xs text-gray-600 mb-0.5">
            Video avatar (optional)
          </label>
          <select
            id={videoFieldId}
            disabled={disabled}
            className="w-full border rounded px-2 py-1 text-sm"
            value={videoAvatarId ?? ''}
            onChange={(e) =>
              onChange({ videoAvatarId: e.target.value === '' ? null : e.target.value })
            }
          >
            <option value="">None</option>
            {videoAvatars.map((a) => (
              <option key={a.id} value={a.id}>
                {a.name}
                {a.gender ? ` (${a.gender})` : ''}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
}
